import { validateFormOtherFieldValue } from '../../../common/validateFormOtherFieldValue';
import { FormElementPlugin } from '../FormElementPlugin';
import {
  DynamicFormMultipleChoice,
  DynamicFormMultiSelectConfig
} from './FormMultiSelectPlugin';

export const FormRadioGroupPlugin: FormElementPlugin<
  any,
  DynamicFormMultiSelectConfig
> = {
  name: 'Multiple choice',
  type: 'RadioGroup',
  dataTypes: ['text', 'integer', 'numeric', 'enum'],
  element: DynamicFormMultipleChoice,
  validate: validateFormOtherFieldValue
};
